import { useState } from "react";

/**
 * «Попробовать доску» прямо на главной.
 *
 * Доска поднимается по нажатию, а не при загрузке страницы: редактор тянет
 * заметный объём, и грузить его тем, кто просто читает про тарифы, незачем.
 *
 * Каждому гостю заводится СВОЯ одноразовая доска. Общая не годится: что
 * нарисовал один посетитель, увидели бы все следующие — на витрине. Такие
 * доски удаляются раз в сутки разбором на сервере.
 */

type State = "idle" | "loading" | "ready" | "error";

const DEFAULT_NOTE = "Черкать можно свободно: доска временная и к утру исчезнет.";

const ERROR_BY_CODE: Record<string, string> = {
  daily_limit: "На сегодня пробных досок больше нет — загляните завтра.",
  foreign_origin: "Пробную доску можно открыть только с этой страницы.",
};

export function HomeBoardDemo() {
  const [state, setState] = useState<State>("idle");
  const [url, setUrl] = useState("");
  const [note, setNote] = useState(DEFAULT_NOTE);

  async function start() {
    setState("loading");
    try {
      const res = await fetch("/api/v1/site/demo-board", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: "{}",
      });
      const data = (await res.json().catch(() => null)) as
        | { url?: string; code?: string }
        | null;
      if (!res.ok || !data?.url) {
        const code = data?.code ?? "";
        throw new Error(ERROR_BY_CODE[code] ?? "Доска не ответила — попробуйте ещё раз.");
      }
      setUrl(data.url);
      setState("ready");
    } catch (e) {
      setNote(e instanceof Error ? e.message : "Доска не ответила — попробуйте ещё раз.");
      setState("error");
    }
  }

  return (
    <section className="wb-home-demo" aria-labelledby="wb-home-demo-title" data-reveal>
      <div className="wb-home-features__head">
        <h2 id="wb-home-demo-title" className="wb-home-features__title">
          Попробуйте прямо здесь
        </h2>
        <p className="wb-home-features__sub">
          Это та же доска, что и на уроке, — без регистрации и установки.
        </p>
      </div>

      <div className="wb-home-demo__win">
        <div className="wb-home-demo__bar">
          <span className="wb-home-demo__dots" aria-hidden="true">
            <i />
            <i />
            <i />
          </span>
          Пробная доска
        </div>

        <div className="wb-home-demo__body">
          {state === "ready" && url ? (
            <iframe
              className="wb-home-demo__frame"
              src={url}
              title="Пробная доска Bezpart"
              referrerPolicy="no-referrer"
              allow="clipboard-write"
            />
          ) : (
            <div className="wb-home-demo__stub">
              <p className="wb-home-demo__stub-title">
                Рисуйте, пишите текст, ставьте стикеры и виджеты.
              </p>
              <button
                type="button"
                className="wb-btn wb-btn--primary wb-btn--lg wb-btn--inline"
                disabled={state === "loading"}
                onClick={() => void start()}
              >
                {state === "loading"
                  ? "Готовим доску…"
                  : state === "error"
                    ? "Попробовать ещё раз"
                    : "Порисовать на доске"}
              </button>
              <p className="wb-home-demo__note">{note}</p>
            </div>
          )}
        </div>
      </div>

      {state === "ready" ? (
        <p className="wb-home-demo__after">
          Чтобы доска сохранилась и открывалась по ссылке — заведите аккаунт: временные
          доски стираются раз в сутки.
        </p>
      ) : null}
    </section>
  );
}
